<template>
  <section>
    <pageHeader>CLOUD SERVICES</pageHeader>
    <UnderLinedHeader class="pt-15 pb-8 white"
      >To Host or Not to Host</UnderLinedHeader
    >
    <v-row align="center" class="pt-0 pb-16 pr-16 pl-16">
      <p class="artice-text text-center">
        In a new era where the internet has endless options, we are trained to
        help take your firm where you want. Who wants to keep their firm on the
        ground when you can take your data to the cloud? Our certified
        consultants and engineers can help you get off regular servers to cloud
        based servers.
      </p>
    </v-row>
    <v-row class="">
      <v-col
        align="center"
        cols="12"
        s="12"
        xs="12"
        lg="12"
        xl="12"
        md="12"
        v-for="(item, index) in cloud_services"
        :key="index"
      >
        <v-row class="px-16">
          <v-col v-html="item.icon"></v-col>
          <v-col align="left">
            <v-container class="" style="padding-right: 5em; padding-left: 5em">
              <div class="text-h4 text-wrap Hdrstyle text-left">
                {{ item.title }}
              </div>
              <hr />
              <div class="contentStyle">{{ item.content }}</div>
              <div><hoveredList class="listStyle" :items="item.list" /></div>
            </v-container>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="contactDiv px-16" align="center">
      <v-col
        align="center"
        class="vcolRight"
        cols="12"
        s="12"
        xs="12"
        lg="6"
        xl="6"
        md="6"
      >
        <span class="" style="">
          Get in touch with us today to ask more about our services.</span
        >
      </v-col>

      <v-col
        align="center"
        class="vcolLeft pr-16"
        cols="12"
        s="12"
        xs="12"
        lg="6"
        xl="6"
        md="6"
      >
        <v-btn class="" outlined color="white"> CONTACT US</v-btn>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import PageHeader from "@/components/global/compnentsMixins/PageHeader.vue";
import UnderLinedHeader from "@/components/global/compnentsMixins/UnderLinedHeader.vue";
import FlipCard from "@/components/global/compnentsMixins/FlipCard.vue";
export default {
  components: { PageHeader, UnderLinedHeader, FlipCard },
  data() {
    return {
      cloud_services: [
        {
          icon: '<img style="" src="../img/softwares/uptime-logo.png" alt="services-cloud-red" width="350" height="321" style="vertical-align:middle;margin:0px 50px">',
          title: "Uptime Legal Systems®",
          content:
            "Uptime Legal Systems® provides a complete Law Office in the Cloud™ to hundreds of law firms around the world. As the premiere full-service legal technology provider, Uptime’s offerings include everything a law firm needs to eliminate in-house IT infrastructure and outside IT support. Services include hosted practice management, cloud-based document & email management, legal-grade email, cloud-based phone service and managed IT for law firms. As the leading Cloud Services provider to law firms, Uptime is the perfect partner to help you plan and execute your law firm startup plan. You can click on either the picture or link above to gain more insight on this cloud service, or you can contact us!",
        },
        {
          icon: '<img src="../img/softwares/aws-logo.png" alt="services-managedservice-red" width="350" height="321" style="vertical-align:middle;margin:0px 50px">',
          title: "Amazon Web Services",
          content:
            "Amazon Web Services (AWS) is a subsidiary of Amazon.com that provides on-demand cloud computing platforms to individuals, companies and governments, on a paid subscription basis. AWS’s version of virtual computers emulate most of the attributes of a real computer including hardware (CPU(s) & GPU(s) for processing, local/RAM memory, hard-disk/SSD storage); a choice of operating systems; networking; and pre-loaded application software such as web servers, databases, CRM, etc.",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
p.artice-text {
  font-family: $primaryFontFamily;
  font-size: 1em;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: Tahoma !important;
}
hr {
  border-top: 2px solid #a81e2d;
  width: 60px;
  margin-top: 20px;
}
.container_background {
  background-color: #f9f9f9 !important;
}

.Hdrstyle {
  font-family: Poppins;
  letter-spacing: 0;
  color: #222;
  font-style: italic;
  font-weight: 700;
  margin-bottom: 24px;
}
.contentStyle {
  font-family: Raleway;
  font-style: normal;
  font-weight: 400;
  padding-top: 20px;
  font-size: 15px;
  line-height: 25px;
  color: #222;
}
.listStyle {
  color: #3d3935;
  font-size: 16px;
  line-height: 18px;
  font-family: open_sansregular;
  margin-bottom: 10px;
}
.contactDiv {
  font-size: 26px;
  color: white;
  font-family: Tahoma, "Helvetica Neue", Helvetica, Arial, sans-serif;
  height: 150px;
  background: #a81e2d;
}
</style>